import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, Typography, IconButton } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import FormTextField from "src/shared/components/FormTextField"; // adjust import path if needed
import { TimeRange } from "../../shared/types/dashboard";

interface TimeRangeControlsProps {
  timeRange: TimeRange;
  customStartDate: string;
  customEndDate: string;
  onTimeRangeChange: (range: TimeRange) => void;
  onCustomStartDateChange: (date: string) => void;
  onCustomEndDateChange: (date: string) => void;
  onRefresh: () => void;
}

const timeRangeOptions: { value: TimeRange; label: string }[] = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "week", label: "This Week" },
  { value: "month", label: "This Month" },
  { value: "year", label: "This Year" },
  { value: "custom", label: "Custom Range" },
];

const TimeRangeControls: React.FC<TimeRangeControlsProps> = ({ timeRange, customStartDate, customEndDate, onTimeRangeChange, onCustomStartDateChange, onCustomEndDateChange, onRefresh }) => {
  const now = new Date();
  const today = now.getFullYear() + "-" +  String(now.getMonth() + 1).padStart(2, "0") + "-" +  String(now.getDate()).padStart(2, "0");


  return (
    <Box className="flex flex-wrap items-center gap-4">
      {/* Time Range Select */}
      <FormControl size="small" className="w-48">
        <InputLabel id="time-range-label">Time Range</InputLabel>
        <Select labelId="time-range-label" value={timeRange} onChange={(e) => onTimeRangeChange(e.target.value as TimeRange)} label="Time Range" className="bg-white">
          {timeRangeOptions.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Custom Date Range */}
      {timeRange === "custom" && (
        <Box className="flex items-center gap-3">
          <FormTextField
            id="start-date"
            label="Start Date"
            type="date"
            value={customStartDate}
            onChange={(e) => onCustomStartDateChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              max: customEndDate || today,
            }}
            className="w-40"
          />
          <Typography className="text-gray-600">to</Typography>
          <FormTextField
            id="end-date"
            label="End Date"
            type="date"
            value={customEndDate}
            onChange={(e) => onCustomEndDateChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              min: customStartDate,
              max: today,
            }}
            className="w-40"
          />
        </Box>
      )}

      {/* Refresh Button */}
      <IconButton onClick={onRefresh} className="bg-gray-100 hover:bg-gray-200 text-gray-700 transition-colors">
        <Refresh fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default TimeRangeControls;
